// extracted by mini-css-extract-plugin
export default {"empty-list":"Wishlist_empty-list__+QcQm"};